export default __webpack_public_path__ + "static/media/Beard_2_C3.ece10d02.svg";